import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37fd6ce4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "row mb-6" }
const _hoisted_23 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_24 = { class: "col-lg-8 fv-row" }
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { class: "row mb-6" }
const _hoisted_28 = { class: "col-lg-4 required col-form-label fw-bold fs-6" }
const _hoisted_29 = { class: "col-lg-8 fv-row" }
const _hoisted_30 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "fv-plugins-message-container" }
const _hoisted_33 = { class: "fv-help-block" }
const _hoisted_34 = { class: "row mb-6" }
const _hoisted_35 = { class: "col-lg-4 required col-form-label fw-bold fs-6" }
const _hoisted_36 = { class: "col-lg-8 fv-row" }
const _hoisted_37 = { class: "fv-plugins-message-container" }
const _hoisted_38 = { class: "fv-help-block" }
const _hoisted_39 = { class: "row mb-6" }
const _hoisted_40 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_41 = { class: "col-lg-8 fv-row" }
const _hoisted_42 = { class: "fv-plugins-message-container" }
const _hoisted_43 = { class: "fv-help-block" }
const _hoisted_44 = { class: "row mb-6" }
const _hoisted_45 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_46 = { class: "col-lg-8 fv-row" }
const _hoisted_47 = { class: "input-group" }
const _hoisted_48 = { class: "row mb-6" }
const _hoisted_49 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_50 = { class: "col-lg-8 fv-row" }
const _hoisted_51 = { class: "input-group" }
const _hoisted_52 = { class: "fv-plugins-message-container" }
const _hoisted_53 = { class: "fv-help-block" }
const _hoisted_54 = { class: "row mb-6" }
const _hoisted_55 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_56 = { class: "col-lg-8 fv-row" }
const _hoisted_57 = {
  key: 0,
  class: "col-lg-4 col-form-label fw-bold fs-6"
}
const _hoisted_58 = { class: "badge badge-light" }
const _hoisted_59 = {
  key: 1,
  class: "col-lg-4 col-form-label fw-bold fs-6"
}
const _hoisted_60 = { class: "badge badge-dark" }
const _hoisted_61 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_62 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_63 = { class: "indicator-label" }
const _hoisted_64 = { class: "indicator-progress" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!
  const _component_AttachmentV2 = _resolveComponent("AttachmentV2")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.can('create', 'settings'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('Edit Product')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Form, {
              class: "form",
              onSubmit: _ctx.onSubmitCreate,
              "validation-schema": _ctx.validationSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('nameEn')), 1),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "nameEn",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('nameEn'),
                        modelValue: _ctx.product.nameEn,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.product.nameEn) = $event))
                      }, null, 8, ["placeholder", "modelValue"]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_ErrorMessage, { name: "nameEn" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('nameAr')), 1),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "nameAr",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('nameAr'),
                        modelValue: _ctx.product.nameAr,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.product.nameAr) = $event))
                      }, null, 8, ["placeholder", "modelValue"]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_ErrorMessage, { name: "nameAr" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate('descriptionEn')), 1),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_Field, {
                        as: "textarea",
                        name: "descriptionEn",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('descriptionEn'),
                        modelValue: _ctx.product.descriptionEn,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.product.descriptionEn) = $event))
                      }, null, 8, ["placeholder", "modelValue"]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_ErrorMessage, { name: "descriptionEn" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.translate('descriptionAr')), 1),
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_Field, {
                        as: "textarea",
                        name: "descriptionAr",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('descriptionAr'),
                        modelValue: _ctx.product.descriptionAr,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.product.descriptionAr) = $event))
                      }, null, 8, ["placeholder", "modelValue"]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_ErrorMessage, { name: "descriptionAr" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.translate('Select Shop')), 1),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "shopId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.product.shopId,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.product.shopId) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_30, _toDisplayString(_ctx.translate('select Shop')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shopList, (shop) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: shop.id,
                              value: shop.id
                            }, _toDisplayString(shop.name), 9, _hoisted_31))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createVNode(_component_ErrorMessage, { name: "shopId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.translate('Select Category')), 1),
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(_component_Field, {
                        name: "categories",
                        modelValue: _ctx.categories,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.categories) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Multiselect, {
                            name: "categories",
                            mode: "tags",
                            "close-on-select": false,
                            requierd: false,
                            label: "nameEn",
                            trackBy: "nameEn",
                            searchable: true,
                            canDeselect: false,
                            placeholder: _ctx.translate('Select Category'),
                            valueProp: "id",
                            options: _ctx.categoryList,
                            noResultsText: _ctx.translate('noResultsFound'),
                            "allow-empty": false,
                            required: true,
                            modelValue: _ctx.categories,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.categories) = $event))
                          }, null, 8, ["placeholder", "options", "noResultsText", "modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(_component_ErrorMessage, { name: "categories" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.translate('Price')), 1),
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "price",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('Price'),
                        modelValue: _ctx.serviceAmount,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.serviceAmount) = $event))
                      }, null, 8, ["placeholder", "modelValue"]),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createVNode(_component_ErrorMessage, { name: "price" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.translate('Discount')), 1),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_Field, {
                          type: "number",
                          name: "KWDiscount",
                          autocomplete: "off",
                          class: "form-control form-control-lg form-control-solid",
                          placeholder: _ctx.translate('Discount'),
                          min: "0",
                          modelValue: _ctx.KWDiscount,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.KWDiscount) = $event))
                        }, null, 8, ["placeholder", "modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.translate('Discount Percentage')), 1),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _createVNode(_component_Field, {
                          type: "number",
                          name: "discount",
                          autocomplete: "off",
                          class: "form-control form-control-lg form-control-solid",
                          placeholder: _ctx.translate('Discount Percentage'),
                          min: "0",
                          max: "100",
                          modelValue: _ctx.serviceDiscount,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.serviceDiscount) = $event))
                        }, null, 8, ["placeholder", "modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _createVNode(_component_ErrorMessage, { name: "discount" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.translate('Status')), 1),
                    _createElementVNode("div", _hoisted_56, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input widget-9-check",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.status) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.status]
                      ])
                    ])
                  ]),
                  (_ctx.serviceDiscount && _ctx.serviceAmount && _ctx.calculatedPayment >= 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_57, [
                        _createTextVNode(" Price After Discount: "),
                        _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.calculatedPayment.toFixed(3)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.serviceDiscount && _ctx.serviceAmount && _ctx.calculatedPayment >= 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_59, [
                        _createTextVNode(" Discount Amount: "),
                        _createElementVNode("span", _hoisted_60, _toDisplayString((_ctx.serviceAmount - _ctx.calculatedPayment).toFixed(3)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("button", {
                    type: "reset",
                    class: "btn btn-white btn-active-light-primary me-2",
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                  }, _toDisplayString(_ctx.translate('discard')), 1),
                  _createElementVNode("button", _hoisted_62, [
                    _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.translate('saveChanges')), 1),
                    _createElementVNode("span", _hoisted_64, [
                      _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                      _hoisted_65
                    ])
                  ], 512)
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_component_AttachmentV2, {
      isDisabled: !_ctx.productId,
      title: "Thumbnail",
      multiple: false,
      attachments: _ctx.thumbnail,
      onSubmitCreate: _ctx.onSubmitCreateThubmnail,
      onDelete: _ctx.deleteAttachment,
      key: _ctx.attachementKey
    }, null, 8, ["isDisabled", "attachments", "onSubmitCreate", "onDelete"])),
    (_openBlock(), _createBlock(_component_AttachmentV2, {
      isDisabled: !_ctx.productId,
      title: "Images",
      attachments: _ctx.productImages,
      onSubmitCreate: _ctx.onSubmitCreateAttachment,
      onDelete: _ctx.deleteAttachment,
      key: _ctx.attachementKey
    }, null, 8, ["isDisabled", "attachments", "onSubmitCreate", "onDelete"]))
  ], 64))
}